import { observer } from 'mobx-react-lite';
import { IconButton } from '@mui/material';
import EventDetailsActions from './EventDetailsActions';
import { ReactComponent as BackIcon } from '../../../../../../assets/icons/patientsWidgetsIcons/backIcon.svg';

const EventDetailsHeader = ({
  onChange,
  uuid,
}: {
  onChange: (uuid: string) => void;
  uuid: string;
}) => {
  return (
    <div className="flex items-cenetr justify-between w-full px-4 py-2 my-2">
      <IconButton onClick={() => onChange('')} className="p-0">
        <BackIcon />
      </IconButton>
      <EventDetailsActions uuid={uuid} />
    </div>
  );
};

export default observer(EventDetailsHeader);
